export const state = {
  kolektifObject: {},
  amountDeposit: 0
};

export const getters = {
  getKolektifObject: (state) => state.kolektifObject,
  getAmountDeposit: (state) => state.amountDeposit
};

export const mutations = {
  setKolektifObject(state, kolektifObject) {
    state.kolektifObject = kolektifObject;
  },
  setAmountDeposit(state, amountDeposit) {
    state.amountDeposit = amountDeposit;
  },
  addKolektifObjectProperty(state, newProperty) {
    state.kolektifObject = { ...state.kolektifObject, ...newProperty };
  },
};

export const actions = {
  setKolektifObject({ commit }, newValue) {
    // console.log('setkolektif')
    commit("setKolektifObject", newValue);
  },
  setAmountDeposit({ commit }, newValue) {
    commit("setLoading", newValue);
  },
  addKolektifObjectProperty({ commit }, newProperty) {
    // console.log("add new kolektif");
    commit("addKolektifObjectProperty", newProperty);
  },
};
